import { ToDateTimeText } from "../../../utils/date";
import Box from "@material-ui/core/Box";
import PageviewIcon from '@material-ui/icons/Pageview';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

export const getViewExportColumns = (exportData, ViewDetail) => {
  const columns = [
    {
      dataField: "DID",
      text: "",
      formatter: (cell, row) => {
        return (
          <Box component="div" display="flex" justifyContent="center">
            <PageviewIcon
              color="action"
              onClick={() => {
                ViewDetail(row.ID);
              }}
            />
            {((row.ENCRYPT_STATUS === "SUCCESS" && row.ISDOWNLOAD === 1) || (row.ENCRYPT_STATUS === "No Decrypt" && row.ISDOWNLOAD === 1) ) ? (

              <CloudDownloadIcon
                color="action"
                onClick={() => {
                  exportData(row.ID);
                }}
              />

            ) : ""}
          </Box>
        );
      },
    },
    {
      dataField: "DOWNLOAD_ID",
      text: "Download ID",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ENCRYPT_STATUS",
      text: "Encrypt Status",
      formatter: (cell, row) => {
        return <>{(row.ENCRYPT_STATUS === "SUCCESS" || row.ENCRYPT_STATUS === "Error" || row.ENCRYPT_STATUS === "FAILED") ? (row.ENCRYPT_STATUS === "FAILED") ? "Error" : row.ENCRYPT_STATUS : row.ENCRYPT_STATUS === "No Decrypt" ? "SUCCESS" : "Running"}</>;
      },
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "ERROR_MESSAGE",
      text: "Error Message",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{row.ERROR_MESSAGE?.substr(0, 100)}{row.ERROR_MESSAGE?.length > 100 ? "..." : ""}</>;
      },
      headerAlign: 'center',
    },
    {
      dataField: "SPI_TEXT",
      text: "Purpose",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "SOURCE_TABLE",
      text: "Source Table",
      sort: true,
      headerAlign: 'center',
    },
    // {
    //   dataField: "TARGET_TABLE",
    //   text: "Target Table",
    //   sort: true,
    // },
    // {
    //   dataField: "DATE_TIME_START",
    //   text: "Export Start",
    //   sort: true,
    //   formatter: (cell, row, rowIndex) => {
    //     return <>{ToDateTimeText(row.DATE_TIME_START)}</>;
    //   },
    // },
    // {
    //   dataField: "DATE_TIME_END",
    //   text: "Export End",
    //   sort: true,
    //   formatter: (cell, row, rowIndex) => {
    //     return <>{ToDateTimeText(row.DATE_TIME_END)}</>;
    //   },
    // },
    // {
    //   dataField: "FILE_NAME",
    //   text: "File Name",
    //   sort: true,
    // },
    {
      dataField: "TOTAL_RECORD",
      text: "Total Record",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "USER_NAME",
      text: "Create By",
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: "CREATED_DATE",
      text: "Create Date",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return <>{ToDateTimeText(row.CREATED_DATE)}</>;
      },
      headerAlign: 'center',
      align: 'center',
    },
  ];
  return columns;
};
